/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CardCreditType } from '@coursera/cds-core';

import { productCardCredit } from 'bundles/product-card/components/ProductCardCredit';
import isCreditOffered from 'bundles/search-common/components/search-cards/isCreditOffered';
import isPremiumProduct from 'bundles/search-common/components/search-cards/isPremiumProduct';
import type { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

type ProductType = (typeof LEARNING_PRODUCTS)[keyof typeof LEARNING_PRODUCTS];

type Props = {
  customBadge?: React.ReactNode;
  productType?: ProductType;
};

export const shouldShowCreditBadge = (productType?: ProductType) => {
  const creditOffered = productType ? isCreditOffered(productType) : false;
  const premiumProduct = productType ? isPremiumProduct(productType) : false;
  return premiumProduct && creditOffered;
};

const LearningProductCardBadge = ({ customBadge, productType }: Props) => {
  if (!customBadge && !productType) {
    return null;
  }

  if (customBadge) {
    return customBadge;
  } else if (shouldShowCreditBadge(productType)) {
    return <CardCreditType creditType={productCardCredit()} />;
  } else {
    return null;
  }
};

export default LearningProductCardBadge;
